import { Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';
import { delay } from 'rxjs/operators';
import { UserAccess } from '../../interfaces/state/entities/user-access.interface';
import { IUserAccessService } from '../../interfaces/services/user-access-service.interface';

@Injectable({ providedIn: 'root' })
export class UserAccessMockService implements IUserAccessService {
  readonly mockAccess: UserAccess = {
    isDeveloper: true,
    isSupport: true,
    isAdmin: true,
    userId: 'eeeeeeee-eeee-eeee-eeee-eeeeeeeeeeee',
    email: 'riley.universal@example.com',
  };

  getUserAccess(): Observable<UserAccess> {
    return of({ ...this.mockAccess }).pipe(delay(80));
  }
}
